import { render, staticRenderFns } from "./SuppliersFormPage.vue?vue&type=template&id=615327fc&scoped=true&"
import script from "./SuppliersFormPage.vue?vue&type=script&lang=js&"
export * from "./SuppliersFormPage.vue?vue&type=script&lang=js&"
import style0 from "./SuppliersFormPage.vue?vue&type=style&index=0&id=615327fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615327fc",
  null
  
)

export default component.exports